import { useNavigate } from 'react-router-dom';
import { ErrorPageContainer } from './ErrorPage.styles';
import { Button } from '@orbita-ui/core';

interface ErrorPageData {
  statusCode: number;
  title: string;
  leadText: string;
}

class NotFoundErrorPageData implements ErrorPageData {
  statusCode = 404;
  title = 'Página no existente';
  leadText = 'No pudimos encontrar lo que estabas buscando.';
}

class ForbiddenErrorPageData implements ErrorPageData {
  statusCode = 403;
  title = 'No tienes acceso';
  leadText =
    'Estas intentando consultar un recurso para el cual no tienes los permisos requeridos.';
}

class ServiceUnavailableErrorPageData implements ErrorPageData {
  statusCode = 503;
  title = 'Servicio no disponible';
  leadText =
    'Lo sentimos, parece que nuestros servidores no responden. Por favor, inténtanlo de nuevo más tarde.';
}

type ErrorPageType = 'not_fonud' | 'forbidden' | 'service_unavailable';

function getErrorPageData(type: ErrorPageType): ErrorPageData {
  switch (type) {
    case 'not_fonud':
      return new NotFoundErrorPageData();
    case 'forbidden':
      return new ForbiddenErrorPageData();
    case 'service_unavailable':
      return new ServiceUnavailableErrorPageData();
  }
}

export function ErrorPage({ error }: { error: ErrorPageType }) {
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  const errorPageData = getErrorPageData(error);

  return (
    <ErrorPageContainer>
      <h1>{errorPageData.statusCode}</h1>
      <p>
        <span className="text-danger">Opps!</span> {errorPageData.title}
      </p>
      <p className="lead">{errorPageData.leadText}</p>
      <Button onClick={goHome}>Volver al inicio</Button>
    </ErrorPageContainer>
  );
}
